<child-header title="{{ data.title }}" (closeEvent)="onNoClick()"></child-header>
<div class="mat-dialog-body">
  <div mat-dialog-content>
    <p>
      {{ data.msg }}
    </p>
  </div>
  <div mat-dialog-content *ngIf="data?.msg2">
    <p>
      {{ data?.msg2 }}
    </p>
  </div>
  <div mat-dialog-actions>
    <button *ngIf="data?.showCancel" mat-button class="button button-red button-mid ok-button" (click)="onNoClick()">Cancel</button>
    <button mat-button class="button button-red button-mid ok-button" (click)="okButton()">{{ data.buttonName ? data.buttonName : 'OK' }}</button>
  </div>
</div>